import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.number.constructor";
import { setPx, getUrlParams, validatenull } from "./util";
import config from "./config";
import { funEval, uuid } from '@/views/visual/dataScreen/js/utils/utils';
import COMMON from '@/views/visual/dataScreen/js/config';
import axios from 'axios';
import { mockData } from "./mock/index.js"; // import '@/views/visual/dataScreen/echart/js/config'
// import '@/views/visual/dataScreen/echart/js/cdn/echarts/4.2.1/echarts.min.js'
// import '@/views/visual/dataScreen/echart/js/cdn/echarts-wordcloud.min.js'
// import '@/views/visual/dataScreen/echart/js/cdn/clappr.min.js'
// import '@/views/visual/dataScreen/echart/js/const/theme/avue.project.js'
// import '@/views/visual/dataScreen/echart/js/const/theme/halloween.project.js'
// import '@/views/visual/dataScreen/echart/js/const/theme/wonderland.project.js'
// import '@/views/visual/dataScreen/echart/js/cdn/vue/2.5.2/vue.min.js'
// import '@/views/visual/dataScreen/echart/js/cdn/axios/1.0.0/axios.min.js'
// import '@/views/visual/dataScreen/echart/js/cdn/element-ui/2.15.0/index.js'
// import '@/views/visual/dataScreen/echart/js/cdn/avue/2.8.23/avue.min.js'
// import '@/views/visual/dataScreen/echart/js/cdn/datav.min.vue.js'
// import '@/views/visual/dataScreen/echart/js/lib/index.umd.min.js'

export default (function () {
  return {
    props: {
      stylesFormatter: Function,
      dataFormatter: Function,
      titleFormatter: Function,
      labelFormatter: Function,
      clickFormatter: Function,
      sqlFormatter: Function,
      formatter: Function,
      echartFormatter: Function,
      dataQuery: Function,
      dataHeader: Function,
      width: {
        type: [Number, String],
        default: 600
      },
      height: {
        type: [Number, String],
        default: 600
      },
      theme: {
        type: String
      },
      child: {
        type: Object,
        default: function _default() {
          return {};
        }
      },
      sql: {
        type: String
      },
      time: {
        type: Number,
        default: 0
      },
      url: {
        type: String
      },
      disabled: {
        type: Boolean,
        default: true
      },
      dataType: {
        type: Number,
        default: 0
      },
      dataMethod: {
        type: String,
        default: 'get'
      },
      id: {
        type: String,
        default: 'main_' + uuid()
      },
      data: {
        type: [Object, String, Array]
      },
      component: {
        type: Object,
        default: function _default() {
          return {};
        }
      },
      option: {
        type: Object,
        default: function _default() {
          return {};
        }
      }
    },
    data: function data() {
      return {
        dynamicQuery: {},
        propQuery: {},
        headerHeight: '',
        checkChart: '',
        myChart: '',
        dataChart: [],
        dataAxios: {},
        dataUrl: '',
        key: false,
        isChart: false,
        styles: {},
        appendCheck: {},
        appendObj: {},
        appendList: [],
        className: ''
      };
    },
    watch: {
      dataAppend: function dataAppend(val) {
        this.appendObj = {};
        this.appendList = [];

        if (!val) {
          this.appendCheck = clearInterval(this.appendCheck);
        } else {
          this.dataChart = [];
        }

        this.updateData();
      },
      echartFormatter: function echartFormatter() {
        this.updateChart && this.updateChart();
      },
      url: {
        handler: function handler(val) {
          this.dataUrl = val || '';
        },
        deep: true,
        immediate: true
      },
      data: {
        handler: function handler() {
          this.updateData();
        },
        deep: true,
        immediate: true
      },
      width: function width() {
        this.updateData();
      },
      height: function height() {
        this.updateData();
      },
      theme: function theme() {
        // 这三句一句都不能少
        this.myChart.dispose();
        this.init();
        this.updateData();
      },
      option: {
        handler: function handler() {
          if (this.myChart && this.isChart) {
            this.updateData();
          }
        },
        deep: true,
        immediate: true
      }
    },
    computed: {
      count: function count() {
        return this.option.count;
      },
      dataAppend: function dataAppend() {
        return this.option.dataAppend;
      },
      dataChartLen: function dataChartLen() {
        return (this.dataChart || []).length;
      },
      switchTheme: function switchTheme() {
        return this.vaildData(this.option.switchTheme, false);
      },
      name: function name() {
        var className = this.$el.className.split(' ')[0];
        var result = className.replace(config.name, '');
        return result;
      },
      minWidth: function minWidth() {
        var val = this.option.minWidth;
        if (val > this.width) return val;
      },
      isApi: function isApi() {
        return this.dataType === 1;
      },
      isSql: function isSql() {
        return this.dataType === 2;
      },
      styleChartName: function styleChartName() {
        var obj = {
          width: setPx(this.minWidth || this.width),
          height: setPx(this.height),
          transform: "scale(".concat(this.component.scale || 1, ") perspective(").concat(this.component.perspective || 500, "px) rotateX(").concat(this.component.rotateX || 0, "deg) rotateY(").concat(this.component.rotateY || 0, "deg) rotateZ(").concat(this.component.rotateZ || 0, "deg)")
        };
        return obj;
      },
      styleSizeName: function styleSizeName() {
        var _this = this;

        return Object.assign({
          width: setPx(this.width),
          height: setPx(this.height)
        }, function () {
          if (_this.minWidth) {
            return {
              overflowX: 'auto',
              overflowY: 'hidden'
            };
          }

          return {};
        }(), this.styles);
      }
    },
    mounted: function mounted() {
      this.init();
    },
    methods: {
      init: function init() {
        this.className = "animated ".concat(this.component.animated || '');
        var main = this.$refs[this.id];

        if (main) {
          // 判断是否图表去初始化
          this.isChart = config.echart.includes(this.name);
          if (this.isChart) this.myChart = window.echarts.init(main, this.theme);

          if (this.name == 'datav') {
            this.isChart = true;
            this.updateData();
          }
        }
      },
      getItemRefs: function getItemRefs() {
        var refList = this.$parent.$parent.$refs;
        var result = {};
        Object.keys(refList).forEach(function (ele) {
          if (ele.indexOf(COMMON.NAME) !== -1) {
            result[ele.replace(COMMON.NAME, '')] = refList[ele][0];
          }
        });
        return result;
      },
      updateClick: function updateClick(params) {
        var refList = this.getItemRefs();
        var indexList = this.child.index;
        var indexName = this.child.paramName;
        if (validatenull(indexName) && validatenull(indexList)) return;
        var p = {};
        p[indexName] = params.value;
        Object.keys(refList).forEach(function (ele) {
          if (indexList.includes(ele)) refList[ele].updateData(p);
        });
      },
      updateAppend: function updateAppend(result) {
        var _this2 = this;

        if (this.validatenull(this.appendObj)) {
          this.appendList = result;
          this.appendObj = result[0];
        } else {
          var appendList = [];

          for (var i = 0; i < result.length; i++) {
            var ele = result[i];
            if (ele.id === this.appendObj.id) break;else appendList.push(ele);
          }

          this.appendObj = result[0];
          appendList.reverse().forEach(function (ele) {
            _this2.appendList.unshift(ele);
          });
        }

        if (this.validatenull(this.appendCheck)) {
          this.appendCheck = setInterval(function () {
            var length = _this2.appendList.length - 1;

            if (length >= 0) {
              var obj = _this2.appendList.splice(length, 1)[0];

              _this2.dataChart.unshift(obj);

              var len = _this2.dataChart.length;

              if (len > _this2.count) {
                _this2.appendList.splice(len - 1, 1);
              }
            }
          }, 2000);
        }
      },
      updateUrl: function updateUrl(url) {
        this.dataUrl = url;
        this.updateData();
      },
      // 更新数据核心方法
      updateData: function updateData() {
        var _this3 = this;

        var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.dynamicQuery = Object.assign(this.dynamicQuery, p);
        console.log('this.dynamicQuery', this.dynamicQuery);
        return new Promise(function (resolve, reject) {
          _this3.resetData && _this3.resetData();
          if (_this3.key) return;
          _this3.key = true;

          var callback = function callback() {
            _this3.key = false;

            var bindEvent = function bindEvent() {
              if (_this3.isChart) _this3.updateChart();
              if (_this3.myChart) _this3.bindClick();

              if (typeof _this3.stylesFormatter === 'function') {
                _this3.styles = _this3.stylesFormatter(_this3.dataChart, _this3.dynamicQuery, _this3.getItemRefs()) || {};
              }

              resolve(_this3.dataChart);
            }; // 动态数据


            if (_this3.isApi) {
              var detail = function detail(res) {
                // 处理返回的数据
                _this3.dataAxios = res;

                var result = function () {
                  if (typeof _this3.dataFormatter === 'function') {
                    return _this3.dataFormatter(res.data, _this3.dataAxios, _this3.getItemRefs());
                  }

                  ;
                  return res.data || {};
                }(); // 延迟效果数据逐步增加


                if (_this3.dataAppend) {
                  _this3.updateAppend(result);
                } else {
                  _this3.dataChart = result;
                }

                bindEvent();
              };

              var result = getUrlParams(_this3.dataUrl);
              var url = result.url;
              if (_this3.validatenull(url)) return;

              var dataQuery = typeof _this3.dataQuery === 'function' && _this3.dataQuery(result);

              var dataHeader = typeof _this3.dataHeader === 'function' && _this3.dataHeader(result) || {};
              var params = Object.assign(result.params, dataQuery, _this3.propQuery, _this3.dynamicQuery);
              console.log('params', {
                method: _this3.dataMethod,
                url: url,
                data: params,
                headers: dataHeader,
                params: params
              });

              if (url.indexOf('./') > -1) {
                console.log('mockData[url]', mockData);
                detail({
                  data: mockData[url]
                });
              } else {
                axios({
                  method: _this3.dataMethod,
                  url: url,
                  data: params,
                  headers: dataHeader,
                  params: params
                }).then(function (res) {
                  console.log('res', res);
                  res = {
                    data: JSON.parse(JSON.stringify(res))
                  };
                  detail(res);
                });
              }
            } else if (_this3.isSql) {
              var sql = JSON.parse(_this3.sql);

              var _result;

              try {
                sql.sql = funEval(sql.sql)(_this3.dynamicQuery);
                _result = JSON.stringify(sql);
              } catch (error) {
                _result = _this3.sql;
              }

              _this3.sqlFormatter(_result).then(function (res) {
                // 静态数据
                if (typeof _this3.dataFormatter === 'function') {
                  _this3.dataChart = _this3.dataFormatter(res.data.result, _this3.dynamicQuery, _this3.getItemRefs());
                } else {
                  _this3.dataChart = res.data.result;
                }

                bindEvent();
              });
            } else {
              // 静态数据
              if (typeof _this3.dataFormatter === 'function') {
                _this3.dataChart = _this3.dataFormatter(_this3.data, _this3.dynamicQuery, _this3.getItemRefs());
              } else {
                _this3.dataChart = _this3.data;
              }

              bindEvent();
            }
          };

          _this3.$nextTick(function () {
            callback();
            clearInterval(_this3.checkChart);

            if (_this3.time !== 0 && _this3.disabled) {
              _this3.checkChart = setInterval(function () {
                callback();
              }, _this3.time);
            }
          });
        });
      },
      getLabelFormatter: function getLabelFormatter(name) {
        if (this.labelFormatter) {
          return this.labelFormatter(name, this.dataChart);
        }

        return name.value;
      },
      // 绑定点击事件
      bindClick: function bindClick() {
        var _this4 = this;

        this.myChart.off('click');
        this.myChart.on('click', function (e) {
          _this4.clickFormatter && _this4.clickFormatter({
            type: _this4.name,
            name: e.name,
            value: e.value && (e.value[2] || e.value),
            data: _this4.dataChart,
            echartEvent: e
          }, _this4.getItemRefs());
        });
      },
      // 下面俩都是chart的公共的方法,就放这里面共用
      getColor: function getColor(index, first) {
        var barColor = this.option.barColor || [];

        if (barColor[index]) {
          var color1 = barColor[index].color1;
          var color2 = barColor[index].color2;
          var postion = (barColor[index].postion || 0.9) * 0.01;
          if (first) return color1;

          if (color2) {
            return {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [{
                offset: 0,
                color: color1 // 0% 处的颜色

              }, {
                offset: postion,
                color: color2 // 100% 处的颜色

              }],
              global: false // 缺省为 false

            };
          }

          return color1;
        }
      },
      ishasprop: function ishasprop(condition, isprop, alwaysObj) {
        return Object.assign(function () {
          return condition ? isprop : {};
        }(), alwaysObj);
      }
    },
    beforeDestroy: function beforeDestroy() {
      clearInterval(this.checkChart);
    }
  };
})();